import httpService from "./http.service";

const levelEndpoint = "levels/";

const levelService = {
  get: async () => {
    const { data } = await httpService.get(levelEndpoint);
    return data;
  },
};
export default levelService;
